<template>
    <div class="pdf-document-viewer">
        <div class="preview-holder">
            <div v-if="loading"
                 class="loader-holder">
                <naj-loader></naj-loader>
            </div>
            <template v-else>
                <div v-if="document"
                     class="attachment-file-viewer">
                    <!-- PDF Document -->
                    <div v-if="hasPdfDocument"
                         class="pdf-container">
                        <div class="pdf-wrapper">
                            <!-- Mobile/Tablet: Show Download Button -->
                            <div v-if="isMobileOrTablet"
                                 class="pdf-holder">
                                <div class="download-section">
                                    <v-btn color="primary"
                                           large
                                           @click="downloadFile">
                                        <v-icon left>
                                            mdi-download
                                        </v-icon>
                                        {{ downloadButtonText }}
                                    </v-btn>
                                </div>
                            </div>

                            <!-- Desktop: Show PDF Viewer -->
                            <div v-if="isDesktop"
                                 class="pdf-holder">
                                <embed class="pdf-viewer" :src="fileUrl" />
                            </div>
                        </div>
                    </div>

                    <!-- Text Document -->
                    <p v-else
                       class="document-text">
                        {{ document }}
                    </p>
                </div>
            </template>
        </div>
        </div>
</template>

<script>
import { getBlobUrl } from '@/modules/lawsuit/helpers/utils';

export default {
  name: 'PdfDocumentViewer',
  props: {
    document: {
      type: String,
      required: false,
      default: null,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasPdfDocument: {
      type: Boolean,
      required: false,
      default: false,
    },
    fileName: {
      type: String,
      required: false,
      default: 'judgement.pdf',
    },
    downloadButtonText: {
      type: String,
      required: false,
      default: 'تحميل المستند',
    },
    autoDownloadOnMobile: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    fileUrl() {
      return getBlobUrl(this.document);
    },
    isMobileOrTablet() {
      return this.$vuetify.breakpoint.mobile || this.$vuetify.breakpoint.smAndDown;
    },
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
  },
  methods: {
    downloadFile() {
      if (!this.document) return;
      
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = this.fileUrl;
      link.download = this.fileName;
      link.style.display = 'none';
      
      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      this.$emit('downloaded', this.fileName);
    },
  },
  watch: {
    document(newValue) {
      // Auto-download on mobile/tablet if enabled
      if (newValue && this.hasPdfDocument && this.isMobileOrTablet && this.autoDownloadOnMobile) {
        this.$nextTick(() => {
          this.downloadFile();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pdf-document-viewer {
  height: 100%;
  width: 100%;
}
    .preview-holder {
        display: block !important;
        height: 600px;
        width: 100%;
    }

.attachment-file-viewer {
  height: 100%;
  width: 100%;
}

    .pdf-container {
        height: 100%;

        .pdf-wrapper {
            height: 100%;
            position: relative;
            min-height: 150px;

            .pdf-holder {
                height: inherit;
                text-align: center;
                line-height: 1;

                .pdf-viewer {
                    max-height: 100%;
                    display: inline-block;
                }

                .download-section {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    padding: 40px 20px;
                }
            }
        }
    }

.naj-pdf-viewer {
  width: 100%;
  height: auto;
  max-height: 80vh;
  overflow-y: auto;
}

.document-text {
  font-size: 18px;
  line-height: 1.8;
  color: #6d6d6d;
  padding: 20px;
}

.loader-holder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 200px;
}
</style>